export default {"src":"/_next/static/media/partner-hero-graphic.7eb11052.svg","height":362,"width":210,"blurWidth":0,"blurHeight":0};